import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeResourceUrl } from '@angular/platform-browser';
import { UtilService } from '../../../../services/util.service';

@Component({
  selector: 'app-create-link',
  templateUrl: './create-link.component.html',
  styleUrls: ['./create-link.component.scss']
})
export class CreateLinkComponent implements OnInit {
  @Input() linkInfo: any;
  fileImg64: string | ArrayBuffer;
  hasImg: boolean = false;
  srcData: SafeResourceUrl;

  constructor(
    private activeModal: NgbActiveModal,
    private utilService: UtilService
  ) {
  }

  ngOnInit(): void {
    this.linkInfo = { ...this.linkInfo };

    this.linkInfo.img ? this.fileImg64 = this.linkInfo.img : this.fileImg64 = '';
    this.hasImg = this.linkInfo.img ? true : false;
    this.srcData = this.fileImg64;

    if (this.linkInfo && this.linkInfo.id) {
      this.linkInfo.img64Upload = false;
    }
  }

  sendData(): any {
    const childrenArr = this.linkInfo.items.map(item => {
      return {
        id: item.id ? item.id : 0,
        value: item.value,
        url: item.url,
        order: item.order,
        detail: (item.detail || []).map(detail => ({
          id: detail.id ? detail.id : 0,
          value: detail.value,
          url: detail.url,
          order: detail.order,
        }))
      };
    });

    const dataToSend = {
      id: this.linkInfo.id,
      url: this.linkInfo.url,
      value: this.linkInfo.value,
      img: this.hasImg ? this.linkInfo.img : '',
      img64: this.hasImg ? this.linkInfo.img64 : '',
      type: this.linkInfo.type,
      order: this.linkInfo.order,
      items: childrenArr,
      img64Upload: this.linkInfo.img64Upload,
    };

    this.activeModal.close(dataToSend);
  }

  createLinkFields() {
    this.linkInfo.items.push({
      value: '',
      url: '',
      order: this.linkInfo.items.length + 1,
    });
  }

  createSubLinkFields(i: number) {
    this.linkInfo.items[i].detail.push({
      value: '',
      url: '',
      order: this.linkInfo.items[i].detail.length + 1,
    });
  }

  deleteLinkField(i: number): any {
    this.linkInfo.items.splice(i, 1);
  }

  deleteSubLinkField(i: number, subI: number): any {
    this.linkInfo.items[i].detail.splice(subI, 1);
  }

  validateEmptyFields(): any {
    if (this.linkInfo.value &&
      this.linkInfo.url &&
      this.linkInfo.type &&
      this.linkInfo.order &&
      this.validateSubMenus()
      // (this.hasImg && this.linkInfo.img)
    ) {
      if (this.hasImg && !this.linkInfo.img) { return false; }
      else if (this.hasImg && this.linkInfo.img) { return true; }
      else { return true; }
    } else {
      return false;
    }
  }

  validateSubMenus() {
    if (!this.linkInfo.items || this.linkInfo.items.length === 0) { return true; }
    var a = this.linkInfo.items.filter(x => !x.value).length;
    var b = this.linkInfo.items.filter(x => !x.url).length;
    var c = this.linkInfo.items.filter(x => !x.order).length;
    return (a > 0 || b > 0 || c > 0) ? false : true;
  }

  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {

        // if (image.width === 72 && image.height === 48) {
        // this.wrongSize['c'] = null;
        this.fileImg64 = image.src;
        this.linkInfo.img = (event.target.files[0]).name;
        this.linkInfo.img64 = this.fileImg64.split(',')[1];

        // this.srcData = this.utilService.getSanitizer(this.fileImg64);
        this.srcData = this.fileImg64;
        this.linkInfo.img64Upload = true;
        // this.benefitData.img64CUpload = (this.benefitData && this.benefitData.id) ? true : null; // Si es editar setea true | si es lectura es indiferente (no se usa)
        // } else {
        // this.wrongSize['c'] = 'Resolución de imagen carrusel no permitida (requerida: 72px x 48px)';
        // return false;
        // }
      }
    };
    reader.onerror = (error) => {
    };
  };
}

